import { createContext, useState } from 'react';

export const RequestAnalysisInfoHook = () => {
  const [platform, setPlatform] = useState('android');
  const [numberOfSubmissions, setNumberOfSubmissions] = useState(0);
  const [submittedAt, setSubmittedAt] = useState<Date | null>(null);

  return {
    platform,
    setPlatform,
    numberOfSubmissions,
    setNumberOfSubmissions,
    submittedAt,
    setSubmittedAt,
  };
};

export const RequestAnalysisInfoContext = createContext(undefined);
